import type { FieldConfig, ValueState } from '../../types'

import { Operators } from '../../constants'
import FieldController from '../Controller'

export default class BooleanController extends FieldController {
	constructor(config: FieldConfig) {
		super(config)
		this.note = config.note
		this.validate = config.validate || this.defaultValidate
	}

	hasValue = () => true
	defaultValidate = ({ value }: ValueState) => {
		const val = Number(value)

		return val !== 0 && val !== 1 ? 'Please select a value.' : null
	}
	getInitialValue = () => ({
		operation: Operators.BL,
		value: 1,
	})
	formatState = ({ value }: ValueState) => ({
		operation: '',
		value: value ? 'true' : 'false',
	})
}
